export default __webpack_public_path__ + "static/media/strasbourg.050c56b9.jpg";